import { ENV_DECLARONS, ENV_VERIFIED_TRAINER, getActiveBrand, getActivePrestationBrandConfig } from "./environment.config";

/**
 * Coordonnées de l'équipe support affichées dans le tableau de bord (carte
 * « Besoin d'aide ? », page Aide et contact). Un téléphone vide n'est pas affiché.
 * Les adresses correspondent à MAIL_CONTACT / MAIL_CONTACT_VT côté serveur.
 */
export interface SupportContact {
    email: string;
    /** Numéro au format international pour le lien tel:, null si non communiqué. */
    phone: string | null;
    /** Numéro tel qu'il est affiché. */
    phoneDisplay: string | null;
    /** Créneaux de joignabilité, texte libre. */
    hours: string;
}

const SUPPORT_HOURS = "du lundi au vendredi, de 9h à 18h";

export const getSupportContact = (): SupportContact => {
    switch (getActiveBrand()) {
        case ENV_VERIFIED_TRAINER:
            return { email: "contact@verified-trainer.com", phone: null, phoneDisplay: null, hours: SUPPORT_HOURS };
        case ENV_DECLARONS:
            return { email: "contact@teachr.fr", phone: null, phoneDisplay: null, hours: SUPPORT_HOURS };
        default:
            return { email: "contact@teachr.fr", phone: null, phoneDisplay: null, hours: SUPPORT_HOURS };
    }
};

/** Sujet présélectionné quand le client signale un problème depuis le détail d'un cours. */
export const SUPPORT_SUBJECT_COURSE_ISSUE = `Problème sur ${getActivePrestationBrandConfig("", "un ", "une ")}`;

/** Sujets proposés dans le formulaire de contact, dans l'ordre d'affichage. */
export const SUPPORT_SUBJECTS = [
    "Question sur une déclaration",
    SUPPORT_SUBJECT_COURSE_ISSUE,
    "Problème de paiement ou de prélèvement",
    "Avance immédiate / URSSAF",
    "Mon compte ou mes informations",
    "Signaler un bug",
    "Autre demande",
];
